import { useEffect, useState } from 'react';
import api from '../api';

export function useTutorialVideos({ pageKey, section } = {}) {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        const params = {};
        if (pageKey) {
            params.page_key = pageKey;
        }
        if (section) {
            params.section = section;
        }
        api.get('tutorial-videos', { params })
            .then((response) => {
                if (cancelled) {
                    return;
                }
                const items = response?.data?.data?.items || response?.data?.items || [];
                setVideos(Array.isArray(items) ? items : []);
            })
            .catch(() => {
                if (!cancelled) {
                    setVideos([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [pageKey, section]);

    return { videos, loading };
}
